import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { NgForm } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { APIError } from "../shared.models";
import { User } from "../models/user.model";
import { UtilsService } from "../utils/utils.service";
import { SettingsService } from "./../settings/settings.service";
import { Settings } from "./../settings/settings.model";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  onDestroy$ = new Subject();
  message: string;
  apiError: APIError = new APIError();
  settings: Settings = new Settings();

  constructor(
    private authService: AuthService,
    private router: Router,
    private settingsService: SettingsService,
    private utilsService: UtilsService
  ) {}

  ngOnInit() {
    // Necessary for hiding the 'Forgotten password' and 'Register for an account link'.
    // TODO: there must be a better way of doing this!
    this.getSettings();
  }

  login(loginForm: NgForm) {
    this.apiError.hasError = false;
    this.authService
      .login(loginForm.value)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.authService.isLoggedIn = true;
          // Get the redirect URL from our auth service
          // If no redirect has been set, use the default
          let redirect = this.authService.redirectUrl
            ? this.authService.redirectUrl
            : "/";
          // Redirect the user
          this.router.navigate([redirect]);
          let user: User = data;
          if (user) {
            this.authService.setUser(user);
          }
        },
        (error) => {
          this.apiError.hasError = true;
          this.authService.isLoggedIn = false;

          if (error.errorMessage) {
            this.apiError = this.utilsService.handleAPIError(error);
          } else {
            if (error.status === 429) {
              this.apiError.errorMessage =
                "Too many login attempts, please wait and try again";
            } else {
              this.apiError.errorMessage =
                "Your username and password combination is incorrect";
            }
          }
        }
      );
  }

  logout() {
    this.authService.logout();
  }

  /**
   * Get the app global settings for the app, eg portal name
   */
  private getSettings(): void {
    this.settingsService
      .getSettings()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.settings = data;
        },
        (error) => {}
      );
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
